import memoize from 'lib/memoize/memoize'
import {
  ExploreMapMarkerProps,
  MapMarkerProps,
} from 'tripPlanner/components/TripMaps/utils'
import { ExploreItem, FullTrip } from 'tripPlanner/types/common'
import { PublicTripItem } from 'tripPlanner/types/publicTrip'
import {
  AttractionItem,
  RestaurantBarItem,
  TripItem,
} from 'tripPlanner/types/tripItem'

export function isExploreItem(
  item: ExploreItem | TripItem,
): item is ExploreItem {
  return 'types' in item
}

export function isExploreMarker(
  marker: MapMarkerProps | ExploreMapMarkerProps,
): marker is ExploreMapMarkerProps {
  return isExploreItem(marker.item)
}

// Use this if you don't want to show the same place twice on the map
// Filter out saved items that have the same place as one of the explore items
export function filterSavedItemsWithExplorePlaces(
  mapMarkers: MapMarkerProps[],
  exploreItems: ExploreItem[],
): MapMarkerProps[] {
  const exploreItemsIds = new Set(
    exploreItems.map((exploreItems) => exploreItems.id),
  )

  return mapMarkers.filter(
    (mapMarker) =>
      !(
        'place' in mapMarker.item &&
        exploreItemsIds.has(mapMarker.item.place.id!)
      ),
  )
}

export function getMatchingSavedExploreItem(
  trip: FullTrip,
  exploreItem: ExploreItem,
): AttractionItem | RestaurantBarItem | undefined {
  return getPlaceIdToSavedExploreItemMap(trip.items).get(
    exploreItem.place.id ?? '',
  ) as AttractionItem | RestaurantBarItem | undefined
}

export const getPlaceIdToSavedExploreItemMap = memoize(
  (items: Array<TripItem | PublicTripItem>) => {
    const map = new Map<string, TripItem | PublicTripItem>()

    items.forEach((item) => {
      if (
        'place' in item &&
        item.place.type === 'GEO' &&
        item.sourceType === 'Explore'
      ) {
        map.set(item.place.id!, item)
      }
    })

    return map
  },
)

export function cleanUrlString(urlString: string): string {
  // Remove 'https://' or 'http://' if present & utm params
  const cleanedUrl = urlString.replace(
    /^(https?:\/\/)?(www\.)?|(\/)?(\?|&)utm_[^&#]+|\/.*$/g,
    '',
  )
  return cleanedUrl
}
